/* eslint-disable */
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#!%*?&!#\$%&()*+,-.:;<=>?@[\\\]^_`{|}~/])(?![\\'"\s])^[^\\'"\s]{8,20}$/;
export const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const dayRegex = /^(0[1-9]|[1@2]\d|3[01])$/;
export const monthRegex = /^(0[1-9]|1[012])$/;
export const yearRegex = /^\d{4}$/;
export const ssnRegex = /^(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/;
export const notOnlyNumberRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9\s.,/#&-]+$/;
export const cityRegex = /^[A-Za-z\s]*$/;
// export const zipCodeRegex = /^[A-Za-z0-9]*[0-9][A-Za-z0-9]*$/;
// export const zipCodeRegex = /^[A-Za-z0-9]*[0-9]{3,5}(?:[\s-][0-9][A-Za-z0-9]{3,4})?$/;
export const zipCodeRegex = /^\d{5}(-\d{4}|[^0-9])?$/;
export const phoneRegex = /^(1\s?)?(\d{3}|\(\d{3}\))[\s\-]?\d{3}[\s\-]?\d{4}$/;
export const onlyAlphabetRegex = /^[A-Za-z]+$/;
export const ResidentialAddressRegex = /^[0-9a-zA-Z\s.,#-]+$/gi;
export const refferedByRegex = '^[a-zA-Z0-9_]*$';
export const whiteSpaceRegex = /\s/;
// export const alphabetSpaceRegex = /^[a-zA-Z\s]*$/;
export const alphabetSpaceRegex = /^(?!\s*$)[a-zA-Z\s]+$/;
